import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
const columns = [
  { field: "id", headerName: "ID", width: 150 },
  { field: "location", headerName: "Location", width: 200 },
  { field: "latitude", headerName: "Latitude", width: 90 },
  { field: "longitude", headerName: "Longitude", width: 90 },
  { field: "speed", headerName: "Speed", width: 90 },
  { field: "status", headerName: "Status", width: 90 },
  { field: "reportedTime", headerName: "Reported Time", width: 120 },
];
const assetsCol = [
  { field: "id", headerName: "ID", width: 200 },
  { field: "type", headerName: "Asset Type", width: 100 },
  { field: "name", headerName: "Name", width: 200 },
  { field: "lastEvent", headerName: "Last Event", width: 150 },
  { field: "lastKnownLoc", headerName: "Last known location", width: 200 },
  { field: "lastKnowLatLng", headerName: "Last known Lat/Lng", width: 150 },
  { field: "status", headerName: "Status", width: 120 },
];
export default function StatedTrackable(props) {
  const [trackablesList, setTrackablesList] = useState([]);
  // Get Vehicle list and append to state
  useEffect(() => {
    // for local testing
    // var token =
    //   "eyJraWQiOiJuc3BpcmUiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJkdmlkbXljaHRlc3QyQHNwaXJlb24uY29tIiwibnM6YXMiOiJwYWFzIiwibnM6c2dpIjpbXSwibnM6c2MiOiJwYWFzIiwiaXNzIjoiaHR0cHM6XC9cL3NwaXJlb24uY29tIiwibnM6YXBwIjoiNTZmN2FiYTUtNGMxYS0xMWVjLThjYzMtMDI0MmFjMTIwMDA4IiwibnM6dCI6ImR2aWRteWNodGVzdDJAc3BpcmVvbi5jb20rNTZmN2FiYTUtNGMxYS0xMWVjLThjYzMtMDI0MmFjMTIwMDA4IiwibnM6cyI6IkFDQ09VTlRfVVNFUl9TQ09QRSIsIm5zOnYiOiJ2MSIsIm5zOnUiOiIzNWM0ZWY1NS04OGI1LTQyYmYtODVmYy1mYTNlNThmNzQwNWUiLCJuczphYiI6InBhYXMiLCJuczpyb2xlIjpbIlJPTEVfQUNDT1VOVF9BRE1JTiIsIlJPTEVfQ09OU1VNRVIiLCJST0xFX0RFQUxFUiIsIlJPTEVfUEFBU19BRE1JTl9BTEwiLCJST0xFX1BBQVNfQURNSU5fQ1JFQVRFX0FMTCIsIlJPTEVfUEFBU19BRE1JTl9ERUxFVEVfQUxMIiwiUk9MRV9QQUFTX0FETUlOX1JFQURfQUxMIiwiUk9MRV9QQUFTX0FETUlOX1VQREFURV9BTEwiLCJST0xFX1BBQVNfVVNFUiIsIlJPTEVfUEFBU19XRUJIT09LX0FETUlOIiwiUk9MRV9QQUFTX1dFQkhPT0tfVVNFUiIsIlJPTEVfVEVMRU1FVFJZX1BST1ZJREVSIiwiUk9MRV9VU0VSIl0sImV4cCI6MTY4MDA5MjI3NywibnM6YiI6InBhYXMiLCJuczphIjoiMTY0MzA2MTkxMzU1MU5RRFhWUTEifQ.vMEeA75pMV7wAS17kKh2JrPQULkLL0nue6erPJdm0F32xay83Et1l2OekW8N26obqyqit3u-PQWB5hMQRsLg0GKJrzg9dEaM-2xuIHP3F8Z0X1NgDkiPC7jrDtA7hQ0ppA6ra6i-s4_ZT4LPYQUONBG7r3mMgFaAWf-Qthg2qFGlYqQCkEjOqIz_6DBIkUjo_C2bkcUvDzsSh8pKb9Ao4e1go2Uclp8SJ-gFE53OQ7vofvv0hb4OqaWh2hkuZbaXK_Aj3IvyKgoEz0A3V6B2DWdfrMXaCgXTXaz0-TtFb5TTKdWMcv9Gtlw7DnIU4d0h3bWXIRXN2BzgpjbrguQxTw";
    // // for dynamic
    const authToken = localStorage.getItem("authToken");
    //const authToken = JSON.parse(localStorage.getItem("authToken")).token;
    console.log(authToken);
    //without API
    const instance = axios.create({
      baseURL: "https://paas-api-proxy-stage.spireon.com/",
      timeout: 100000,
      //for local testing
      //headers: { Authorization: "Bearer " + token },
      //for dynamic
      headers: { Authorization: "Bearer " + JSON.parse(authToken).token },
    });

    const func = async () => {
      let res = await instance.get("/v1/stated-trackables");
      let content = await res.data.content;
      debugger;
      let tList;
      console.log(content);
      if (props.dataType === "states") {
        tList = content.map((val) => {
          return {
            id: val.id,
            location:
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.line1
                  ? val.state.lastLocation.address.line1
                  : ""
                : "") +
              "," +
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.city
                  ? val.state.lastLocation.address.city
                  : ""
                : "") +
              "," +
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.stateOrProvince
                  ? val.state.lastLocation.address.stateOrProvince
                  : ""
                : "") +
              "," +
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.postalCode
                  ? val.state.lastLocation.address.postalCode
                  : ""
                : ""),
            latitude: val.state.lastLocation?.lat,
            longitude: val.state.lastLocation?.lng,
            reportedTime: val.state.locationLastReported,
            speed: val.state.speed,
            status: val.state.status,
          };
        });
      } else {
        tList = content.map((val) => {
          return {
            id: val.id,
            type: val.asset?.type,
            name: val.asset?.name,
            lastEvent: val.asset?.lastUpdated,
            timeSinceLastUpdated: "",
            lastKnowLoc:
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.line1
                  ? val.state.lastLocation.address.line1
                  : ""
                : "") +
              "," +
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.city
                  ? val.state.lastLocation.address.city
                  : ""
                : "") +
              "," +
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.stateOrProvince
                  ? val.state.lastLocation.address.stateOrProvince
                  : ""
                : "") +
              "," +
              (val.state.lastLocation?.address
                ? val.state.lastLocation.address.postalCode
                  ? val.state.lastLocation.address.postalCode
                  : ""
                : ""),
            lastKnowLatLng:
              val.state.lastLocation?.lat + "/" + val.state.lastLocation?.lng,
            status: val.asset.active ? "Active" : "Inactive",
          };
        });
      }

      setTrackablesList(tList);
      //dispatch(sktrDetailsSlice.actions.setVehicleList(vList));
    };
    func();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div style={{ height: 300, width: "100%" }}>
      <p style={{ fontWeight: 800, margin: 0, paddingLeft: "10px" }}>State</p>
      <DataGrid
        rows={trackablesList}
        columns={props.dataType === "states" ? columns : assetsCol}
        pageSize={3}
        rowsPerPageOptions={[5]}
        //checkboxSelection
      />
    </div>
  );
}
